import { HisValueGroup } from '../../model/his-value-group';
import { Component, Input, OnInit, ViewChild, Injector, inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldDirective } from './field.directive';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisComponentRegistryService } from '../../service/his-component-registry.service';
import { OldNewFieldContainerComponent } from './old-new-field-container.component';
import { HisUrlUtils } from '../../../core/utils';
import { HisBaseGlobalsService } from '../../../core/service/base/his-base-globals.service';

@Component( {
    selector: 'his-dynamicfield',
    templateUrl: './his-dynamicfield.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDynamicFieldComponent implements OnInit {
    private hisComponentRegistryService = inject(HisComponentRegistryService);
    hisBaseGlobalsService = inject(HisBaseGlobalsService);

    @Input() dynamicFieldConfig: HisDynamicFieldConfig;
    @Input() form: UntypedFormGroup;
    @Input() valueGroup: HisValueGroup;
    @ViewChild( FieldDirective, { static: true } ) dynamicFieldHost: FieldDirective;
    get isValid() { return this.form.controls[this.dynamicFieldConfig.name].valid; }

    ngOnInit() {
        console.log( 'INIT ' + this.dynamicFieldConfig.name );
        this.loadComponent();
    }

    loadComponent() {

        const myInjector = this.createInjector();

        if (this.dynamicFieldConfig.useOldValue) {
            this.dynamicFieldHost.viewContainerRef.createComponent( OldNewFieldContainerComponent, { index: 0, injector: myInjector } );
        } else {
            // Determine Component for input field type
            let comp = this.hisComponentRegistryService.getComponentClass( this.dynamicFieldConfig.controlType );
            // Use Component factory to create the Component instance and a Reference to it
            this.dynamicFieldHost.viewContainerRef.createComponent( comp, { index: 0, injector: myInjector } );
        }
    }

    createInjector(): Injector {
        return Injector.create(
            {
                providers: [
                    {
                        provide: 'injectedData',
                        useValue: {
                            formGroup: this.form,
                            options: this.dynamicFieldConfig,
                            valueGroup: this.valueGroup
                        }
                    }
                ]
            }
        );

    }

    // Mögliche URL-Params, root ist erforderlich
    //&root=fs.res.project.project.editComponentRoot
    //&tab=fs.res.common.dynamicContent.tab.dynamicFields
    //&fieldset=fs.res.project.Accounting
    //&field = ''
    //&anchorPosition=3
    //&sortorder=2

    getLinkToPageRulesetEditor(): string {
        let baseUrl = HisUrlUtils.getBaseUrl();
        let linktToRulesetEditor = '/a/cs.sys.adminutils.frontend/ruleseteditor';
        console.log('dynamicFieldConfig #dynamicFieldConfig', this.dynamicFieldConfig);
        console.log('dynamicFieldConfig #dynamicFieldConfig.children', this.dynamicFieldConfig.children);
        console.log('dynamicFieldConfig #valueGroup', this.valueGroup);
        console.log('dynamicFieldConfig #valueGroup.getJson()', this.valueGroup.getJson());
        console.log('dynamicFieldConfig #form', this.form);
        // let root =
        // let tab =

        // dynamic.fs.res.project.Accounting.accountingRecordSource
        // hier kann man nicht ddKey verwenden, es ist optional
        let field  = this.dynamicFieldConfig.name;
        // let anchorPosition =
        // let sortorder =
        console.log('getLinkToPageRulesetEditor() #field', field);

        // fieldset kann man nicht ableiten aus dynamic.fs.res.project.Accounting.accountingRecordSource
        //let fieldset =

        return baseUrl + linktToRulesetEditor;
    }

}
